<template>
  <router-view />
</template>

<script>
export default {
  name: "KPI"
};
</script>

<style></style>
